<template>
  <div>
    <el-dialog
      title=""
      @close="closeDialog"
      :visible="dialogFormVisible"
      width="600px"
      center>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item :label="$t('default.name')" prop="name" required>
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('default.remark')" prop="remark">
          <el-input v-model="ruleForm.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">{{$t('default.cancel')}}</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">{{$t('default.submit')}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['dialogFormVisible'],
  data () {
    return {
      ruleForm: {
        name: '',
        remark: '',
        _id: ''
      },
      rules: {
        name: [
          { required: true, message: 'please enter name', trigger: 'blur' }
        ]
      }
    }
  },
  beforeMount () {
  },
  methods: {
    closeDialog () {
      this.ruleForm = {
        name: '',
        remark: '',
        _id: ''
      }
      this.$emit('update:dialogFormVisible', false)
      this.$refs.ruleForm.resetFields()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const doc = {
            name: this.ruleForm.name,
            remark: this.ruleForm.remark,
            id: this.ruleForm._id
          }
          this.$store.httpDispatch({})('insertOrganization', doc).then((res) => {
            const { code, data } = res.data
            if (code === 0) {
              this.ruleForm._id = data.id
              this.$notify.success({ title: 'Success', message: '操作成功', duration: 5000 })
              this.$emit('refresh')
              this.closeDialog()
            }
          }).catch((err) => {
            console.log(err)
            this.$notify.error({ title: 'Error', message: `[${err.data.code}] ${err.data.msg}`, duration: 5000 })
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    edit (row) {
      this.ruleForm = {
        name: row.name,
        remark: row.remark,
        _id: row._id
      }
    }
  }
}
</script>
